import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('fieldops_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Force login on every new session (Cold Launch)
    if (!sessionStorage.getItem('fieldops_session_init')) {
      localStorage.removeItem('fieldops_token');
      localStorage.removeItem('fieldops_user');
      sessionStorage.setItem('fieldops_session_init', 'true');
      setUser(null);
      setLoading(false);
      return;
    }

    const token = localStorage.getItem('fieldops_token');
    if (token) {
      authAPI.me()
        .then(res => setUser(res.data.user))
        .catch(() => { localStorage.removeItem('fieldops_token'); localStorage.removeItem('fieldops_user'); setUser(null); })
        .finally(() => setLoading(false));
    } else setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { token, user } = res.data;
    localStorage.setItem('fieldops_token', token);
    localStorage.setItem('fieldops_user', JSON.stringify(user));
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('fieldops_token');
    localStorage.removeItem('fieldops_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
